module.exports = __webpack_public_path__ + "static/media/header_logo_plate.4e5d80b8.png";